import React from "react";

const Modal = ({ isOpen, title, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-navy/60 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl border-2 border-primary p-6 max-w-sm w-full animate-fadeIn">
        <h2 className="text-xl font-extrabold text-primary mb-2 text-center">{title}</h2>
        <p className="mb-5 text-center text-navy">{message}</p>
        <button
          className="bg-primary hover:bg-yellow text-navy font-bold py-2 px-8 rounded-xl mx-auto block transition"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default Modal;
